import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import * as markerjs2 from 'markerjs2';
import {DokumentModels} from 'src/app/models/dokument-models';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';

@Component({
    selector: 'app-image-editor',
    templateUrl: './image-editor.component.html',
    styleUrls: ['./image-editor.component.scss'],
})
export class ImageEditorComponent implements OnInit, AfterViewInit {
    @ViewChild('img') img!: ElementRef;
    markerArea: any;
    sharedImage!: DokumentModels.DokumentBild;
    imgURL: any;
    image: any;
    public isZoomed = false;

    constructor(
        private svcMessageBox: MessageBoxService,
        public dialogRef: MatDialogRef<ImageEditorComponent>,
        private svcDokuData: DokumentDataService,
        @Inject(MAT_DIALOG_DATA) public data: DokumentModels.DokumentBild,
        private sanitizer: DomSanitizer
    ) {
        let binaryData: any[] = [];
        binaryData.push(data.binary);
        this.imgURL = URL.createObjectURL(new Blob(binaryData, {type: this.data.binary.type}));
        this.image = this.sanitizer.bypassSecurityTrustUrl(this.imgURL);
    }

    ngAfterViewInit(): void {
        if (this.data.doEdit) {
            this.showMarkerArea();
        }
    }

    ngOnInit(): void {
    }

    zoomIn(): void {
        this.isZoomed = true;
    }

    zoomOut(): void {
        this.isZoomed = false;
    }

    toggleZoom(): void {
        this.isZoomed = !this.isZoomed;
    }

    dataURItoBlob(dataURI: string): Blob {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString: string;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = unescape(dataURI.split(',')[1]);
        }

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type: mimeString});
    }

    async showMarkerArea() {
        if (this.img !== undefined) {
            this.markerArea = new markerjs2.MarkerArea(this.img?.nativeElement);
            markerjs2.Activator.addKey('MJS2-F045-M583-6415');
            this.markerArea.settings.displayMode = 'popup';
            //this.markerArea.renderAtNaturalSize = true;
            this.markerArea.addEventListener('render', (event: any) => {
                console.log('markerArea: Render Event', event);
                this.img.nativeElement.src = event.dataUrl;

                this.data.binary = this.dataURItoBlob(event.dataUrl);
                this.svcDokuData.uploadBild(this.data).subscribe({
                    next: () => {
                        this.svcMessageBox.showSuccess(
                            'Das Bild wurde erfolgreich aktualisiert.',
                            'Erfolgreich'
                        );
                    },
                    error: (err) => {
                        if (err.error.code == 'IllegalFileName') {
                            this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                        } else {
                            this.svcMessageBox.showError('Das Bild konnte nicht aktualisiert werden!!', '!! FEHLER !!');
                        }
                    },
                });
            });

            await new Promise((f) => setTimeout(f, 100)); // Wenn dieser Sleep nicht drin ist, wird ein weisses Bild angezeigt
            this.markerArea.show();
        }
    }

    closeWindow() {
        this.dialogRef.close();
    }
}
